import { observer } from 'mobx-react-lite';
import React from 'react';

import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import formatDuration from '@smart-tv/utils/formatter/format-duration';

import { rootStore } from '../_stores/store-root';

export const SheetDescriptionInfoMeta = observer(() => {
  const { providerName, year, duration, textSeparator } =
    rootStore.sheetStore.sheet.infoBlock || {};

  const hasYear = typeof year === 'number' && year > 0;
  const hasDuration = typeof duration === 'number' && duration > 0;

  if (!providerName && !hasYear && !hasDuration && !textSeparator) {
    return null;
  }

  const channelText = [
    providerName,
    hasYear ? year : undefined,
    hasDuration ? formatDuration(duration) : undefined
  ]
    .filter((part) => part !== undefined && part !== null && part !== '')
    .join((textSeparator ?? '').toString());

  if (!channelText) {
    return null;
  }

  return (
    <Typography variant="caption2" data-testid={testIds.programsheet.info.meta}>
      {channelText}
    </Typography>
  );
});

export default SheetDescriptionInfoMeta;
